export type AssetSpecValue = string | number | boolean | null;

export type AssetSpecItem = [TranslationKey, AssetSpecValue];

export type AssetSpecsGroup = AssetSpecItem[];

export type AssetSpecsSection = AssetSpecsGroup[];

export enum PlatformBusClass {
    City = 'City',
    Intercity = 'Intercity',
    Touristic = 'Touristic',
    SchoolBus = 'SchoolBus',
}
